import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Container,
  Dropdown,
  Form,
  Tab,
  Nav,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Card from "../../../components/Card";
import moment from "moment";
import loader from "../../../assets/images/page-img/page-load-loader.gif";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import "./Style.css";
import "./TestMeet.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { getToken } from "../../../utils/auth";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../utils/useAuth";
import { MdOutlineDone } from "react-icons/md";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { CiMail } from "react-icons/ci";
import { IoCallOutline } from "react-icons/io5";
import { CiGlobe } from "react-icons/ci";
import { BsPatchCheckFill } from "react-icons/bs";
import Sponsored1 from "../Sponsored1";
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";
import { useUser } from "../../../Context/UserContext";
import { Country, State } from 'country-state-city';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'
import validatePhoneNumber from "../../../utils/validatePhoneNumber";
import validateEmail from "../../../utils/validateEmail";
const Meet = () => {
  useAuth();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (!getToken()) {
      navigate("/auth/sign-in");
    }
  }, []);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [loadingFull, setLoadingFull] = useState(false);
  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [formData, setFormData] = useState({
    fullName: "",
    birthday: "",
    gender: "",
    bio: "",
    hobbies: [],
    address: "",
    city: "",
    state: "",
    zipCode: "",
    country:"",
    currentLocation: "",
    lookingFor: "",
    zodiac: "",
    ageRange: { min: 25, max: 35 },
    email: "",
    mobile: "",
  });
    const [countryName, setCountryName] = useState("")
  
const getCountryCodeByName = (countryName) => {
  const country = Country.getAllCountries().find(
    (c) => c.name === countryName
  );
  return country?.isoCode || "";
};

const handlePhoneChange = (phone, field) => {
  setFormData((prev) => ({
    ...prev,
    [field]: phone,
  }));
};

  const [showModal, setShowModal] = useState(false);
  const [contactInfo, setContactInfo] = useState({
    email: '',
    phone: ''
  });

  const handleOpenModal = (data) => {
    setContactInfo({
      email: data?.email,
      phone: data?.mobile
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleAgeRangeChange = (e) => {
    const selectedRange = e.target.value;
  
    let min = 0;
    let max = 0;
  
    // Map the selected range to min and max values
    switch (selectedRange) {
      case "20-25":
        min = 20;
        max = 25;
        break;
      case "25-30":
        min = 25;
        max = 30;
        break;
      case "30-35":
        min = 30;
        max = 35;
        break;
      case "35-40":
        min = 35;
        max = 40;
        break;
      case "40+":
        min = 40;
        max = 100; // You can adjust the upper limit as needed
        break;
      default:
        min = 0;
        max = 0;
    }
  
    setFormData({
      ...formData,
      ageRange: {
        min: min,
        max: max,
      },
    });
  };
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  
  //   if (name === "ageRange.min" || name === "ageRange.max") {
  //     setFormData({
  //       ...formData,
  //       ageRange: {
  //         ...formData.ageRange,
  //         [name.split(".")[1]]: value,
  //       },
  //     });
  //   } else {
  //     setFormData({
  //       ...formData,
  //       [name]: value,
  //     });
  //   }
  // };

const handleAddHobby = () => {
  const hobbyInput = document.getElementById("hobby-input").value;
  if (hobbyInput) {
    setFormData({
      ...formData,
      hobbies: [...formData.hobbies, hobbyInput],
    });
    document.getElementById("hobby-input").value = "";
  }
};

const handleRemoveHobby = (index) => {
  const updatedHobbies = formData.hobbies.filter((_, i) => i !== index);
  setFormData({
    ...formData,
    hobbies: updatedHobbies,
  });
};

  const addHobby = () => {
    setFormData({
      ...formData,
      hobbies: [...formData.hobbies, ""],
    });
  };

  const [post, setPost] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [entertainment, setEntertainment] = useState([]);
  const [entries, setEntries] = useState("");
  const [postType, setPostType] = useState("");
  const [totalPages, setTotalPages] = useState(1);


  const handleAllPost = async (updateData = false) => {
    try {
      const token = getToken();
      let url = `${process.env.REACT_APP_URL}/api/post/category/all?page=${page}&limit=5&category=meet`;
      if (postType) {
        url += `&searchFor=${postType}&country=${countryName}`;
      }
      const response = await axios.get(url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // "Content-Type": "multipart/form-data",
          },
        }
      );
      // console.log("Meet Fetched Successfully", response.data.data.allPosts);
      if (updateData) {
        setEntertainment(response.data.data.allPosts);
      } else {
        setEntertainment((prevPost) => [...prevPost, ...response.data.data.allPosts]);
      }
      setTotalPages(response.data.data.noOfEntries%5===0?response.data.data.noOfEntries/5:parseInt(response.data.data.noOfEntries/5)+1);
    } catch (error) {
      console.log("Failed Fetching Meet", error);
    }
  };

  useEffect(() => {
    if(page===1)
      {
        handleAllPost(true)
      }else{
        handleAllPost();
      }
  }, [page,postType]);
  const [upcoming, setUpcoming] = useState([]);
  const handleUpcoming = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/event/upcoming/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // "Content-Type": "multipart/form-data"
          },
        }
      );
      // console.log(
      //   "Upcoming Event Fetched Successfully",
      //   response.data.data.allEvents
      // );
      setUpcoming(response.data.data.allEvents);
    } catch (error) {
      console.log("Failed Fetching Upcoming Event", error);
    }
  };

  useEffect(() => {
    handleUpcoming();
  }, []);


   const { userData } = useUser();
   const profileImage = userData?.profileImageLink ? userData?.profileImageLink : "/profile.png";


    const [imagePreview, setImagePreview] = useState(null);

    const handleFileInputChange = (event) => {
      const files = Array.from(event.target.files);
      setSelectedFile(files);
      const previews = files.map(file => URL.createObjectURL(file));
      setImagePreview(previews);
      toast.success("File selected!");
  }; 
// console.log("formdata", formData)
  const [photos, setPhotos] = useState([]);
  const handlePost = async () => {
    const MAX_SIZE = 1 * 1024 * 1024;
    for (let i = 0; i < selectedFile.length; i++) {
      if (selectedFile[i].size > MAX_SIZE) {
        toast.error(`File size must not exceed 1MB`);
        return;
      }
    }
    if (!formData.fullName || !formData.birthday || !formData.gender || !formData.bio || 
      !formData.address ||
      !formData.city ||
      !formData.state ||
      !formData.country ||
      !formData.zipCode || !formData.lookingFor || !formData.zodiac || !formData.ageRange.min || !formData.ageRange.max || !formData.mobile || !formData.email || !selectedFile) {
      toast.error("Please fill required fields");
      return;
    }
          if (selectedFile.length === 0) {
        toast.error("Please select at least one image.");
        return;
      }
    try {
      setLoadingFull(true)
      const token = getToken();
      const formData = new FormData();
      for (let i = 0; i < selectedFile.length; i++) {
        formData.append("files", selectedFile[i]);
      }

      const uploadResponse = await axios.post(
        `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("oath", uploadResponse.data.data);

      setPhotos(uploadResponse.data.data);
      postPhoto(uploadResponse.data.data);

      //   setShow(false);
    } catch (error) {
      console.log("Failed to create post:", error);
      toast.error(
        error?.uploadResponse?.data?.message || "Failed to Upload Image/Video"
      );
    } finally{
      setLoadingFull(false)

    }
  };

    const handleVisitCount = async () => {
      try {
          const token = getToken();
          const response = await axios.post(
              `${process.env.REACT_APP_URL}/api/stats/module`,
              {
                  moduleType: "deals"
              }, {
              headers: {
                  "Authorization": `Bearer ${token}`,
                  "Content-Type": "application/json"
              }
          }
          );
          
      } catch (error) {
          console.error('Failed Visit count', error);
      }
  
  }
  useEffect(()=>{
      handleVisitCount();
  },[])
  
  const postPhoto = async (photoss) => {
    if (!formData.fullName || !formData.birthday || !formData.gender || !formData.bio || 
      !formData.address ||
      !formData.city ||
      !formData.state ||
      !formData.country ||
      !formData.zipCode ||
       !formData.lookingFor || !formData.zodiac || !formData.ageRange.min || !formData.ageRange.max || !formData.mobile || !formData.email || !selectedFile) {
      toast.error("Please fill required fields");
      return;
    }

    setLoadingFull(true)

  if (!(await validateEmail(formData.email))) {
    toast.error("Invalid Email");
        setLoadingFull(false)
    return;
  }

  if (!(await validatePhoneNumber(formData.mobile))) {
    toast.error("Invalid phone number.");
        setLoadingFull(false)
    return;
  }

    try {
      setLoadingFull(true)
      const token = getToken();
      const postData = {
        fullName: formData.fullName,
        birthday: formData.birthday,
        gender: formData.gender,
        bio: formData.bio,
        hobbies: formData.hobbies,
        location: {
          address: formData.address,
          city: formData.city,
          state: formData.state,
          zipCode: formData.zipCode,
          country: formData.country
        },
        lookingFor: formData.lookingFor,
        zodiac: formData.zodiac,
        ageRange: formData.ageRange,
        mobile: formData.mobile,
        email: formData.email,
        photos: photoss,
      };

      const postResponse = await axios.post(
        `${process.env.REACT_APP_URL}/api/post/meet`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      handleAllPost(true);
      // console.log("Post Successfully", postResponse.data);
      toast.success("Post created successfully");
      setDescription("");
      setSelectedFile([]);
      setImagePreview(null)
      setFormData({
        fullName: "",
        birthday: "",
        gender: "",
        bio: "",
        hobbies: [],
        address: "",
        city: "",
        state: "",
        zipCode: "",
        country: "",
        currentLocation: "",
        lookingFor: "",
        zodiac: "",
        ageRange: { min: 25, max: 35 },
        email: "",
        mobile: "",
      });
        setShow(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.log("Failed Posting ", error);
    }  finally{
      setLoadingFull(false)

    }
  };

  const [user, setUser] = useState("");

  const fetchUserData = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("user details header", response.data.data);
      setUser(response?.data?.data);
      const countryCode = response?.data?.data?.country || "";
                  const countryInfo = Country.getCountryByCode(countryCode);
                  const countryNameFromList = countryInfo?.name || "";
                  setCountryName(countryNameFromList)
                  setFormData((prev) => ({ ...prev, country: countryNameFromList }));
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };
  useEffect(() => {
    fetchUserData();
  }, [])

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    const day = now.getDate().toString().padStart(2, "0");
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };


  const [dropdown, setDropdown] = useState();

  const handleDropdown = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/default-setting`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("Category Dropdown fetched", response.data.data.isDefaultSettingsExist);
      setDropdown(response.data.data.isDefaultSettingsExist);
    } catch (error) {
      console.error("Failed Fetching dropdown", error);
    }
  };
useEffect(()=>{
  handleDropdown();
},[]);

  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>
{loadingFull && (
    <div style={styles.loaderOverlay}>
      <CircularProgress style={{ color: "white" }} />
    </div>
  )}
<div id="content-page" className="content-page">
        <Container>
          <Row>
          
          <Col lg="12">
              <Tab.Container defaultActiveKey="f1">
                <Card className="cardnavbar">
                  <div className="user-tabing">
                   <Nav
                                        variant="pills"
                                        className="connection-tabs-nav p-0 m-0 round"
                                      >
                                        <Nav.Item as="li">
                                          <Nav.Link
                                            onClick={(e) => {
                                              setPostType("");
                                              setPage(1);
                                            }}
                                            className="text-center"
                                            eventKey="f1"
                                            href="#"
                                          >
                                            {t("my_posts")}
                                          </Nav.Link>
                                        </Nav.Item>
                  
                                        <Nav.Item as="li">
                                          <Nav.Link
                                            onClick={(e) => {
                                              setPostType("all");
                                              setPage(1);
                                            }}
                                            className="text-center"
                                            eventKey="f2"
                                            href="#"
                                          >
                                            {t("other_posts")}
                                          </Nav.Link>
                                        </Nav.Item>
                                      </Nav>
                  </div>
                </Card>
                <Tab.Content className="forum-content">
                  <Tab.Pane eventKey="f1">
                 <FullBody
                 profileImage={profileImage} handleShow={handleShow} post={post} setPage={setPage} page={page} totalPages={totalPages} entertainment={entertainment} t={t} handleOpenModal={handleOpenModal}
                 />
                  </Tab.Pane>
                  <Tab.Pane eventKey="f2">
                  <FullBody
                 profileImage={profileImage} handleShow={handleShow} post={post} setPage={setPage} page={page} totalPages={totalPages} entertainment={entertainment} t={t} handleOpenModal={handleOpenModal}
                 />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Col> 
            <Modal
                    size="lg"
                    className="fade"
                    id="post-modal"
                    onHide={handleClose}
                    show={show}
                    style={{ marginTop: "100px", maxHeight: "80vh" }}
                  >
                    <Modal.Header className="d-flex justify-content-between">
                      <Modal.Title id="post-modalLabel">
                        {t('createPostMeet')}
                      </Modal.Title>
                      <Link to="#" className="lh-1" onClick={handleClose}>
                        <span className="material-symbols-outlined">close</span>
                      </Link>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="d-flex align-items-center">
                        {/* <div className="user-img">
                                                    <img src={profileImage} alt="user1" className="avatar-60 rounded-circle img-fluid" />
                                                </div> */}
                        <form
                          className="post-text ms-3 w-100 "
                          data-bs-toggle="modal"
                          data-bs-target="#post-modal"
                        >
                          {/* <input type="text" className="form-control rounded" placeholder="What's on your mind?" style={{border:"none"}} onChange={(e)=> setDescription(e.target.value)}/> */}
                          {/* <EmojiPicker /> */}
                          {/* <br /> */}
                        </form>
                      </div>
                      {/* <hr /> */}
                           <Form.Group className="form-group mb-3">
              <Form.Label>
                {t("fullName")} <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                placeholder={t("enterFullName")}
                required
              />
            </Form.Group>

            {/* Bio */}
            <Form.Group className="form-group mb-3">
              <Form.Label>
                {t("bio")} <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                name="bio"
                value={formData.bio}
                onChange={handleChange}
                rows={3}
                required
              />
            </Form.Group>

            {/* Birthday */}
            <Form.Group className="form-group mb-3">
              <Form.Label>
                {t("birthday")} <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="date"
                name="birthday"
                value={formData.birthday}
                onChange={handleChange}
                max={new Date().toISOString().split("T")[0]}
                required
              />
            </Form.Group>

            {/* Hobbies */}
            <Form.Group className="form-group mb-3">
        <Form.Label>
          {t("hobbies")} <span style={{ color: "red" }}>*</span>
        </Form.Label>
        <div className="d-flex mb-3">
          <Form.Control
            type="text"
            id="hobby-input"
            placeholder="Enter a hobby"
          />
          <Button onClick={handleAddHobby} variant="primary" className="ms-2" style={{whiteSpace:"nowrap"}}>
            {t("addHobby")}
          </Button>
        </div>
        <ul>
          {formData.hobbies.map((hobby, index) => (
           <li key={index} className="d-flex justify-content-between align-items-center" style={{marginBlock:"3px"}}>
           <span>{hobby}</span>
           <Button
             onClick={() => handleRemoveHobby(index)}
             variant="danger"
             size="sm"
             className="ms-2"
           >
             {t("remove")}
           </Button>
         </li>
         
          ))}
        </ul>
      </Form.Group>

            {/* Location */}
            <div className="col-md-12 mb-1 ">
                          <Form.Group className="form-group">
                            <Form.Label>
                              {t('address')} <span style={{ color: "red" }}>*</span>{" "}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="address"
                              value={formData.address}
                              onChange={handleChange}
                              className="mb-0 py-2"
                              id=""
                              placeholder={t('address')}
                              required
                            />
                          </Form.Group>
                        </div>
                      
                        <div className="col-12 m-0 p-0">
  <div className="row col-12 p-0 m-0">
    <div className="col-6 p-0 pe-2 m-0">
      <Form.Group className="form-group">
        <Form.Label>
          {t("country")} <span style={{ color: "red" }}>*</span>{" "}
        </Form.Label>
        <Form.Select
          name="country"
          value={formData.country}
          onChange={(e) => {
            const selectedCountryName = e.target.value;
            setFormData({
              ...formData,
              country: selectedCountryName,
              state: "",
            });
          }}
          className="mb-0 py-2"
          required
        >
          <option value="">{t("selectCountry")}</option>
          {Country.getAllCountries().map((country) => (
            <option key={country.isoCode} value={country.name}>
              {country.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </div>

    <div className="col-6 p-0 m-0">
      <Form.Group className="form-group">
        <Form.Label>
          {t("state")} <span style={{ color: "red" }}>*</span>{" "}
        </Form.Label>
        <Form.Select
          name="state"
          value={formData.state}
          onChange={handleChange}
          className="mb-0 py-2"
          required
          disabled={!formData.country}
        >
          <option value="">{t("selectState")}</option>
          {formData.country &&
            State.getStatesOfCountry(getCountryCodeByName(formData.country)).map(
              (state) => (
                <option key={state.isoCode} value={state.name}>
                  {state.name}
                </option>
              )
            )}
        </Form.Select>
      </Form.Group>
    </div>
  </div>
</div>


                        <div className="col-12 m-0 p-0 ">
                        <div className="row col-12 p-0 m-0 " >
  <div className="col-6 p-0 pe-2 m-0 ">
  
    <Form.Group className="form-group">
                            <Form.Label>
                              {t('city')} <span style={{ color: "red" }}>*</span>{" "}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="city"
                              value={formData.city}
                              onChange={handleChange}
                              className="mb-0 py-2"
                              id=""
                              placeholder={t('city')}
                              required
                            />
                          </Form.Group>
  </div>
  <div className="col-6 p-0 m-0">
    <Form.Group className="form-group">
      <Form.Label>
        {t('pincode')} <span style={{ color: "red" }}>*</span>{" "}
      </Form.Label>
      <Form.Control
        type="text"
        name="zipCode"
        value={formData.zipCode}
        onChange={(e) => {
          const re = /^[0-9]{0,6}$/;
          if (re.test(e.target.value)) {
            setFormData(prevState => ({
              ...prevState,
              zipCode: e.target.value
            }));
          }
        }}
        className="mb-0 py-2"
        placeholder={t('pincode')}
        required
      />
    </Form.Group>
  </div>
</div>

                      </div>
                      <div className="col-12 p-0 m-0">
                                                        <div className="row col-12 p-0 m-0">
                                                          <div className="col-6 p-0 pe-2 m-0">
                                                            <Form.Group className="form-group">
                                                              <Form.Label>
                                                                {t('mobile')} <span style={{ color: "red" }}>*</span>{" "}
                                                              </Form.Label>
                                                                                                <PhoneInput
                                                                                                                                     country={(user?.country || "us").toLowerCase()} 
                                                                  value={formData.mobile}
                                                                  onChange={(phone) => handlePhoneChange(phone, "mobile")}
                                                                  inputStyle={{ width: "100%", paddingBlock:"20px" }}
                                                                  required
                                                                />
                                                            </Form.Group>
                                                          </div>
                                                          <div className="col-6 p-0 m-0">
                                                            <Form.Group className="form-group">
                                                              <Form.Label>
                                                                {t('email_label')} <span style={{ color: "red" }}>*</span>{" "}
                                                              </Form.Label>
                                                              <Form.Control
                                                                type="email"
                                                                name="email"
                                                                value={formData.email}
                                                                onChange={handleChange}
                                                                className="mb-0 py-2"
                                                                id=""
                                                                placeholder={t('email_placeholder')}
                                                                required
                                                                
                                                              />
                                                            </Form.Group>
                                                          </div>
                                                        </div>
                                                      </div>


            {/* Gender */}
            <Form.Group className="form-group mb-3">
              <Form.Label>
                {t("gender")} <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                as="select"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                required
              >
                <option value="">{t("selectGender")}</option>
                 {dropdown?.gender?.map((category, index) => (
                                  <option key={index} value={category}>
                                    {category}
                                  </option>
                                ))}
                {/* <option value="">{t("selectGender")}</option>
                <option value="male">{t("male")}</option>
                <option value="female">{t("female")}</option>
                <option value="other">{t("other")}</option> */}
              </Form.Control>
            </Form.Group>

            {/* Looking For */}
            <Form.Group className="form-group mb-3">
              <Form.Label>
                {t("lookingFor")} <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                as="select"
                name="lookingFor"
                value={formData.lookingFor}
                onChange={handleChange}
                required
              >
                <option value="">{t("selectLookingFor")}</option>
                 {dropdown?.lookingFor?.map((category, index) => (
                                  <option key={index} value={category}>
                                    {category}
                                  </option>
                                ))}
                 {/* <option value="">Select Looking For</option>
          <option value="friendship">Friendship</option>
          <option value="relationship">Relationship</option>
          <option value="casual">Casual</option>
          <option value="networking">Networking</option>
          <option value="any">Any</option> */}
              </Form.Control>
            </Form.Group>

            {/* Zodiac */}
            <Form.Group className="form-group mb-3">
              <Form.Label>
                {t("zodiac")} <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                as="select"
                name="zodiac"
                value={formData.zodiac}
                onChange={handleChange}
                required
              >
                              <option value="">{t("selectZodiac")}</option>

                 {dropdown?.zodiac?.map((category, index) => (
                                  <option key={index} value={category}>
                                    {category}
                                  </option>
                                ))}
                {/* <option value="">{t("selectZodiac")}</option>
                <option value="Aries">{t("aries")}</option>
                <option value="Taurus">{t("taurus")}</option>
                <option value="Gemini">{t("gemini")}</option>
                <option value="Cancer">{t("cancer")}</option>
                <option value="Leo">{t("leo")}</option>
                <option value="Virgo">{t("virgo")}</option>
                <option value="Libra">{t("libra")}</option>
                <option value="Scorpio">{t("scorpio")}</option>
                <option value="Sagittarius">{t("sagittarius")}</option>
                <option value="Capricorn">{t("capricorn")}</option>
                <option value="Aquarius">{t("aquarius")}</option>
                <option value="Pisces">{t("pisces")}</option> */}
              </Form.Control>
            </Form.Group>

            {/* Age Range */}
            <Form.Group className="form-group mb-3">
  <Form.Label>
    {t("ageRange")} <span style={{ color: "red" }}>*</span>
  </Form.Label>
  <div className="d-flex">
    <Form.Control
      as="select"
      name="ageRange"
      value={
        formData.ageRange.min && formData.ageRange.max
          ? `${formData.ageRange.min}-${formData.ageRange.max}`
          : ""
      }
      onChange={handleAgeRangeChange}
      required
    >
      <option value="">{t("selectAgeRange")}</option>
      <option value="20-25">{t("20-25")}</option>
      <option value="25-30">{t("25-30")}</option>
      <option value="30-35">{t("30-35")}</option>
      <option value="35-40">{t("35-40")}</option>
      <option value="40+">{t("40+")}</option>
    </Form.Control>
  </div>
</Form.Group>



                          <Form.Label>
                          {t('image')} <span style={{ color: "red" }}>*</span>{" "}
                          </Form.Label>
                          <label
                            htmlFor="file-input"
                            style={{ cursor: "pointer", width: "100%" }}
                          >
                            <div
                              className="bg-soft-primary rounded p-1 pointer"
                              style={{
                                width: "100%",
                                textAlign: "center",
                                fontSize: "1.2rem",
                                position: "relative",
                                borderRadius: "10px",
                              }}
                            >
                              <input
                                id="file-input"
                                type="file"
                                name="image"
                                multiple
                                style={{ display: "none" }}
                                onChange={handleFileInputChange}
                              />
                              <span>
                                {selectedFile.length > 0 ? (
                                  <MdOutlineDone style={{ fontSize: "25px" }} />
                                ) : (
                                  <i className="fas fa-upload"></i>
                                )}
                              </span>
                              <p style={{ marginTop: ".5rem" }}>
                                {t('click_to_select_files')}
                              </p>
                            </div>
                          </label>
                          {imagePreview && imagePreview.length > 0 && (
                            <div className="mt-2">
                                {imagePreview.map((preview, index) => (
                                    <img key={index} src={preview} alt={`Selected ${index}`} style={{ width: '70px', borderRadius: '10px', marginBottom: '10px' }} />
                                ))}
                            </div>
                        )}
                       
                      {/* <hr /> */}

                      <button
                        type="submit"
                        className="btn btn-primary d-block w-100 mt-3"
                        onClick={handlePost}
                      >
                        {t('post')}
                      </button>
                    </Modal.Body>
                  </Modal>
                  <Modal
size="md" centered
className="fade"
show={showModal}
onHide={handleCloseModal}
style={{ marginTop: "100px", maxHeight: "80vh" }}
>
<Modal.Header className="d-flex justify-content-between">
  <Modal.Title id="post-modalLabel">
    {t('contact_information')}
  </Modal.Title>
</Modal.Header>
<Modal.Body>
  <div>
    {contactInfo.email && (
      <p>
        <strong>{t("email_label")} : </strong>
        <a href={`mailto:${contactInfo.email}`} style={{ textDecoration: 'none' }}>
          {contactInfo.email}
        </a>
        <CiMail 
          size={20} 
          style={{ marginRight: "5px", fontWeight: "600", marginLeft: "10px", cursor: "pointer" }} 
          onClick={() => window.location.href = `mailto:${contactInfo.email}`} 
        />
      </p>
    )}

    {contactInfo.phone && (
      <p>
        <strong>{t("phone_label")} : </strong>
        <a href={`tel:${contactInfo.phone}`} style={{ textDecoration: 'none' }}>
          + {contactInfo.phone}
        </a>
        <IoCallOutline 
          size={18} 
          style={{ marginRight: "5px", marginLeft: "10px", cursor: "pointer" }} 
          onClick={() => window.location.href = `tel:${contactInfo.phone}`} 
        />
      </p>
    )}

    {!contactInfo.email && !contactInfo.phone && (
      <p>{t("contactInformationNotAvailable")}</p>
    )}
    <button
      type="button"
      className="btn btn-primary d-block w-100 mt-3"
      onClick={handleCloseModal}
    >
      {t('close')}
    </button>
  </div>
</Modal.Body>
</Modal>
          </Row>
        </Container>
      </div>
    </>
  );
};

const FullBody = ({ profileImage, handleShow, post, setPage, page, totalPages, entertainment, t, handleOpenModal}) => {
  return(
    <Col lg={12} className="row m-0 p-0">
    <Col sm={12}>
      <Card
        id="post-modal-data"
        className="card-block card-stretch card-height"
      >
        <div className="card-header d-flex justify-content-between">
          <div className="header-title">
            <h4 className="card-title">{t('createPostMeet')}</h4>
          </div>
        </div>
        <Card.Body>
          <div className="d-flex align-items-center">
            <div className="user-img">
              <img
              src={profileImage}
                // src={`${user?.profileImageLink ? user?.profileImageLink : '/profile.png'}`}
                alt="user1"
                className="avatar-60 rounded-circle"
              />
            </div>
            <form
              className="post-text ms-3 w-100 "
              onClick={handleShow}
            >
              <input
                type="text"
                className="form-control rounded"
                placeholder={t('writeSomethingHere')}
                style={{ border: "none" }}
              />
            </form>
          </div>

        </Card.Body>
       
      </Card>
    </Col>
    <Sponsored1 />

    <InfiniteScroll
      style={{ overflowX: "hidden" }}
      dataLength={post.length}
      next={() => setPage((page) => page + 1)}
      hasMore={page<totalPages}
      loader={
        <div className="col-sm-12 text-center">
          <img
            src={loader}
            alt="loader"
            style={{ height: "100px" }}
          />
        </div>
      }
      endMessage={entertainment?.length!==0 && (<p className="text-center">{t('no_more_posts')}</p>)}
    >
      {entertainment?.length === 0 ? (
        <div>{t('no_posts_yet')}</div>
      ) : (
        entertainment?.map((post, index) => (
          <Col sm={12} key={index}>
  <div key={post?._id} className="post-card">
    <div className="post-content">
      {/* Left Side: Post Information */}
      <div className="post-info">
        <h2>{post?.fullName} | {post?.location?.city}</h2>
        <div className="about-description">
          <span dangerouslySetInnerHTML={{ __html: post?.bio }}></span>
        </div>
        <p style={{textTransform:"capitalize"}}><strong>{t("birthday")}:</strong> {moment(post?.birthday).format('MMMM Do YYYY')} | <strong>Looking For:</strong> {post?.lookingFor}</p>
        <p className="">
          <strong>{t("hobbies")}:</strong> {post?.hobbies?.join(', ')}
        </p>
        {post?.location ? (<p className=""><strong>{t('location')}:</strong> {post?.location?.address}, {post?.location?.city}, {post?.location?.state}, {post?.location?.country}, {post?.location?.zipCode}</p>): (<div></div>)}

          <p><strong>{t("contact_information")}:</strong> {post?.contactInfo?.mobile}, {post?.contactInfo?.email}</p>
          <p>  <button className="buttonsend" 
          onClick={()=>handleOpenModal(post?.contactInfo)}
          ><CiMail size={20} style={{marginRight:"5px", fontWeight:"600"}}/>{t('send_enquiry')}</button></p>
      </div>

      {/* Right Side: Image Carousel */}
      <div className="carousel-container">
        <Carousel
          showArrows={false}
          showThumbs={false}
          showStatus={false}
          infiniteLoop
          autoPlay
          interval={2000}
        >
          {post?.photos?.map((image, index) => (
            <div key={index}>
              <img
                src={image}
                className="rounded image-enter"
                alt={`carousel-${index}`}
                onError={(e) => { e.target.onerror = null; e.target.src = "/profile.png"; }}
              />
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  </div>
</Col>

        ))
      )}
    </InfiniteScroll>
  </Col>
  )
}
const styles = {
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};
export default Meet;
